<template>
	<Dialog v-bind:value="value" @input="$emit('input', $event)"
					title="Position zurücksetzen ?"
					@ok="submit" ok-text="Zurücksetzen" :loading="loading"
					@cancel="close">
		Soll die Position <b>{{ positionName }}</b>
		wirklich auf den _default Zustand zurückgesetzt werden?
	</Dialog>
</template>

<script>
import Dialog from "../../../components/Dialog";

export default {
	name: "ResetPositionDialog",
	components: {Dialog},
	props: ['value', 'position'],
	data: () => {
		return {
			name: null,
			loading: false,
		}
	},
	computed: {
		positionName() {
			return this.position ? this.position.name : null;
		},
		vuexState() {
			return this.$store.state.zones;
		},
		selectedSite() {
			return this.$store.state.display.selectedSite;
		},
		selectedType() {
			return this.$store.state.display.selectedType;
		},
	},
	methods: {
		async submit() {
			this.loading = true;
			let data = await this.$store.dispatch('zones/resetPosition', this.getBody());
			this.loading = false;
			if (data.Status) {
				this.$root.$emit('snackbar', 'Position ' + this.positionName + ' erfolgreich zurückgesetzt.')
				this.$emit('reset');
				this.close();
			}
		},
		getBody() {
			return {
				position_id: this.position.PositionId,
				type_id: this.selectedType.SitetypeId,
				zone_id: this.vuexState.zoneDetails.Zone.ZoneId,
			}
		},
		close() {
			this.$emit('input', false); // set v-model to false -> close dialog
		}
	},
}
</script>

<style scoped>

</style>